export const BenchmarkMetadataSmallDisplayTestIds = {
  Id: 'BenchmarkMetadata_SmallDisplay_Id',
  Type: 'BenchmarkMetadata_SmallDisplay_Type',
  BaseCurrency: 'BenchmarkMetadata_SmallDisplay_BaseCurrency',
  WeightingMethodology: 'BenchmarkMetadata_SmallDisplay_WeightingMethodology',
  CalculationFrequency: 'BenchmarkMetadata_SmallDisplay_CalculationFrequency',
  RebalanceFrequency: 'BenchmarkMetadata_SmallDisplay_RebalanceFrequency',
  JobSchedule: 'BenchmarkMetadata_SmallDisplay_JobSchedule',
  InceptionDate: 'BenchmarkMetadata_SmallDisplay_InceptionDate',
  CreatedDate: 'BenchmarkMetadata_SmallDisplay_CreatedDate',
  LagDate: 'BenchmarkMetadata_SmallDisplay_LagDate',
  LatestPerformance: 'BenchmarkMetadata_SmallDisplay_LatestPerformance',
  PACalendar: 'BenchmarkMetadata_SmallDisplay_PACalendar',
  UseDailyToMonthlyLinking:
    'BenchmarkMetadata_SmallDisplay_UseDailyToMonthlyLinking',
  LookThroughDepth:
    'BenchmarkMetadata_SmallDisplay_LookThroughDepth',
  PerformanceVariationCode:
    'BenchmarkMetadata_SmallDisplay_PerformanceVariationCode',
  IncludeBookedValues: 'BenchmarkMetadata_SmallDisplay_IncludeBookedValues',
  Description: 'BenchmarkMetadata_SmallDisplay_Description',
  NumberOfDaysInYear: 'BenchmarkMetadata_SmallDisplay_NumberOfDaysInYear',
  PushTimeWindowsToPortfolioAnalytics:
    'BenchmarkMetadata_SmallDisplay_PushTimeWindowsToPortfolioAnalytics',
};

export const BenchmarkMetadataDefaultDisplayTestIds = {
  Id: 'BenchmarkMetadata_DefaultDisplay_Id',
  Type: 'BenchmarkMetadata_DefaultDisplay_Type',
  BaseCurrency: 'BenchmarkMetadata_DefaultDisplay_BaseCurrency',
  WeightingMethodology: 'BenchmarkMetadata_DefaultDisplay_WeightingMethodology',
  CalculationFrequency: 'BenchmarkMetadata_DefaultDisplay_CalculationFrequency',
  RebalanceFrequency: 'BenchmarkMetadata_DefaultDisplay_RebalanceFrequency',
  JobSchedule: 'BenchmarkMetadata_DefaultDisplay_JobSchedule',
  InceptionDate: 'BenchmarkMetadata_DefaultDisplay_InceptionDate',
  CreatedDate: 'BenchmarkMetadata_DefaultDisplay_CreatedDate',
  LagDate: 'BenchmarkMetadata_DefaultDisplay_LagDate',
  LatestPerformance: 'BenchmarkMetadata_DefaultDisplay_LatestPerformance',
  PACalendar: 'BenchmarkMetadata_DefaultDisplay_PACalendar',
  UseDailyToMonthlyLinking:
    'BenchmarkMetadata_DefaultDisplay_UseDailyToMonthlyLinking',
  PerformanceVariationCode:
    'BenchmarkMetadata_DefaultDisplay_PerformanceVariationCode',
  IncludeBookedValues: 'BenchmarkMetadata_DefaultDisplay_IncludeBookedValues',
  LookThroughDepth: 'BenchmarkMetadata_DefaultDisplay_LookThroughDepth',
  Description: 'BenchmarkMetadata_DefaultDisplay_Description',
  NumberOfDaysInYear: 'BenchmarkMetadata_DefaultDisplay_NumberOfDaysInYear',
  PushTimeWindowsToPortfolioAnalytics:
    'BenchmarkMetadata_DefaultDisplay_PushTimeWindowsToPortfolioAnalytics',
};
